import {
  MechanicInstallation,
  FormattedDocument,
  Profile,
  FormattedDocumentItem,
  InstallationModule
} from "@/types";

export default (
  installation: MechanicInstallation,
  profile: Profile,
  installationModule: InstallationModule
): FormattedDocument => [
  {
    title: "Installatie",
    items: [
      {
        type: "text",
        title: "Adres",
        value: installation.address
      },
      {
        type: "text",
        title: "Bewoner",
        value: installation.tenant
      },
      {
        type: "text",
        title: "Telefoonnummer",
        value: installation.phone || "Onbekend"
      },
      {
        type: "text",
        title: "Email",
        value: installation.email || "Onbekend"
      },
      {
        type: "image",
        title: "Woningcorporatie",
        value:
          (installation.housingCooperative && installation.housingCooperative.logoUrl) || "Onbekend"
      },
      {
        type: "text",
        title: "Monteur",
        value: profile?.name ?? "Onbekend"
      },
      {
        type: "text",
        title: "Email monteur",
        value: profile?.email ?? "Onbekend"
      },
      {
        type: "text",
        title: "Installateur",
        value: installation?.installer || "Onbekend"
      },
      {
        type: "text",
        title: "Contactpersoon (installateur)",
        value: installation.installerContact?.name ?? "Onbekend"
      },
      {
        type: "text",
        title: "Email contactpersoon (installateur)",
        value: installation.installerContact?.email ?? "Onbekend"
      },
      {
        type: "text",
        title: "Telefoon",
        value: installation.installerContact?.phone ?? "Onbekend"
      },
      {
        type: "text",
        title: "Contactpersoon (Wocozon)",
        value: (installation.wocozonContact && `${installation.wocozonContact.email}`) || "Onbekend"
      },

      ...(installation.comment
        ? ([
            {
              type: "text",
              title: "Commentaar (schouwers)",
              value: installation.comment.trim() || "Leeg"
            }
          ] as FormattedDocumentItem[])
        : []),

      {
        type: "text",
        title: "Datum (aangepast)",
        value: new Date().toLocaleDateString()
      },
      {
        type: "text",
        title: "Tijd (aangepast)",
        value: new Date().toLocaleTimeString()
      },
      {
        type: "text",
        title: "Nummer van de bus",
        value: installationModule?.data?.numberOfBus || "Nog niet ingevuld"
      }
    ]
  }
];
